import reducer from './reducers';

import * as userInfoSelectors from './selectors';
import * as userInfoOperations from './operations';
import * as userInfoTypes from './types';

export { userInfoSelectors, userInfoOperations, userInfoTypes };

export default reducer;
